/* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import "react-multi-date-picker/styles/colors/green.css";
import { format } from "date-fns";

import { useEffect, useState } from "react";
import { DateObject, Calendar } from "react-multi-date-picker";
// import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CalendarDaysIcon } from "lucide-react";

export const RangeDateSelector = ({
  onChange,
  date /* defaultValue */,
  onTempDateChange,
  isDocument,
}: any) => {
  const [value, setValue] = useState<any>([
    new DateObject().subtract(6, "days"),
    new DateObject(),
  ]);

  useEffect(() => {
    if (value?.[0] && value?.[1]) {
      onTempDateChange?.(value);
    }
  }, [value]);
  // useEffect(() => {
  //   console.log({ defaultValue });
  //   if (defaultValue?.[0] && defaultValue?.[1]) {
  //     setValue([
  //       new DateObject({ date: defaultValue[0], format: "DD-MM-YYYY" }),
  //       new DateObject({ date: defaultValue[1], format: "DD-MM-YYYY" }),
  //     ]);
  //   } else {
  //     console.log("{ defaultValue }");
  //     setValue([new DateObject().subtract(6, "days"), new DateObject()]);
  //   }
  // }, [defaultValue]);

  useEffect(() => {
    if (isDocument) {
      const document_range = sessionStorage.getItem("document-range");
      try {
        if (document_range) {
          const formatedDate = JSON.parse(document_range || "");
          setTimeout(() => {
            setValue([
              new DateObject({ date: formatedDate[0], format: "DD-MM-YYYY" }),
              new DateObject({ date: formatedDate[1], format: "DD-MM-YYYY" }),
            ]);
          });
        }
      } catch (error) {
        console.log({ error });
      }
    }
  }, []);

  const selectionList = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last-7-days", label: "Last 7 days" },
    { value: "last-30-days", label: "Last 30 days" },
    { value: "this-month", label: "This Month" },
    { value: "last-month", label: "Last Month" },
    { value: "last-90-days", label: "Last 90 Days" },
    { value: "custom-selection", label: "Custom Selection" },
  ];

  const [selections, setSelections] = useState<any>("custom-selection");

  const [open, setOpen] = useState<any>(false);

  const manageSelection = (prop: string) => {
    setSelections(prop);
    switch (prop) {
      case "today": {
        const today = new DateObject();
        const start = new DateObject(today);
        const end = new DateObject(today);
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "yesterday": {
        const yesterday = new DateObject().subtract(1, "day");
        const start = new DateObject(yesterday);
        const end = new DateObject(yesterday);
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "last-7-days": {
        const end = new DateObject();
        const start = new DateObject(end).subtract(6, "days");
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "last-30-days": {
        const end = new DateObject();
        const start = new DateObject(end).subtract(29, "days");
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "this-month": {
        const now = new DateObject();
        const start = new DateObject(now).setDay(1);
        const end = new DateObject(now).add(1, "month").setDay(0);

        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "last-month": {
        const lastMonth = new DateObject().subtract(1, "month");
        const start = new DateObject(lastMonth).setDay(1);
        const end = new DateObject(lastMonth).add(1, "month").setDay(0);
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      case "last-90-days": {
        const end = new DateObject();
        const start = new DateObject(end).subtract(89, "days");
        setValue([start, end]);
        onChangeHandle([start, end]);
        break;
      }
      default:
        setValue([]);
        break;
    }
  };

  useEffect(() => {
    if (date?.[0] && date?.[1]) {
      console.log(date);
      setValue([
        new DateObject({ date: date[0], format: "DD-MM-YYYY" }),
        new DateObject({ date: date[1], format: "DD-MM-YYYY" }),
      ]);
    }
  }, [date]);

  useEffect(() => {
    if (!value?.[0] || !value?.[1]) {
      console.log(value);
      setSelections("custom-selection");
    }
  }, [value]);

  const onChangeHandle = (prop?: any) => {
    console.log(value);
    if (prop) {
      if (prop?.[0] && prop?.[1]) {
        const formattedRange = [
          prop[0].format("DD-MM-YYYY"),
          prop[1].format("DD-MM-YYYY"),
        ];
        onChange(formattedRange);
        sessionStorage.setItem(
          "document-range",
          JSON.stringify([
            prop[0].format("DD-MM-YYYY"),
            prop[1].format("DD-MM-YYYY"),
          ]),
        );
        setOpen(false);
      }
    }
  };

  const submit = () => {
    if (value?.[0] && value?.[1]) {
      console.log("prop");
      const formattedRange = [
        value[0].format("DD-MM-YYYY"),
        value[1].format("DD-MM-YYYY"),
      ];
      sessionStorage.setItem(
        "document-range",
        JSON.stringify([
          value[0].format("DD-MM-YYYY"),
          value[1].format("DD-MM-YYYY"),
        ]),
      );
      onChange(formattedRange);
      setOpen(false);
    }
  };

  const displayDate = selectionList.find(
    (item: any) => item.value === selections,
  );

  return (
    <div className="flex items-center gap-3 flex-col md:flex-row">
      <Popover open={open} onOpenChange={setOpen}>
        {/* <Label className="text-sm">Select Date</Label> */}
        <PopoverTrigger className="flex border rounded-md px-3 py-2 text-sm w-[240px] justify-between">
          {displayDate?.value === "custom-selection" ? (
            <div>
              <span className="text-slate-500">
                {value?.[0] ? format(value[0].toDate(), "MMM dd yyyy") : ""}
              </span>
              <span className="mx-2">to</span>
              <span className="text-slate-500">
                {value?.[1] ? format(value[1].toDate(), "MMM dd yyyy") : ""}
              </span>
            </div>
          ) : (
            displayDate?.label
          )}
          <CalendarDaysIcon size={16} />
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[670px]" align="end">
          <div className="flex gap-3">
            {/* Selection List */}
            <div className="border flex flex-col justify-evenly py-2 px-2 items-start text-left border-l-0 border-b-0 border-t-0">
              {selectionList.map((item: any) => (
                <Button
                  key={item.value}
                  onClick={() => manageSelection(item.value)}
                  className={cn(
                    "h-auto inline-block p-0 w-full !text-left px-2 py-1 ",
                    item.value !== selections && "text-[#72767d]",
                  )}
                  variant={item.value === selections ? "default" : "ghost"}
                >
                  {item.label}
                </Button>
              ))}
            </div>

            {/* Calendar */}
            <div>
              <Calendar
                className="green"
                value={value}
                onChange={setValue}
                range
                numberOfMonths={2}
                // currentDate={value?.[0] ?? new DateObject()}
                currentDate={value?.[1] ?? new DateObject()}
              />
              <div className="border-t p-3 flex justify-end gap-3">
                <Button
                  className="w-[120px]"
                  onClick={() => setOpen(false)}
                  variant={"outline"}
                >
                  Cancel
                </Button>
                <Button className="w-[120px]" onClick={submit}>
                  Select
                </Button>
              </div>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
